"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantStatus = exports.InputFieldFieldType = exports.InputFieldType = exports.WorkspaceIntegrationType = exports.IntegrationType = exports.VideoIntegrationType = exports.SchedulerLocationPhoneTab = exports.SchedulerHeaderTab = exports.SchedulerLocationTab = void 0;
var SchedulerLocationTab;
(function (SchedulerLocationTab) {
    SchedulerLocationTab["VIDEO_CONFERENCE"] = "VIDEO_CONFERENCE";
    SchedulerLocationTab["IN_PERSON"] = "IN_PERSON";
    SchedulerLocationTab["PHONE_CALL"] = "PHONE_CALL";
})(SchedulerLocationTab = exports.SchedulerLocationTab || (exports.SchedulerLocationTab = {}));
var SchedulerHeaderTab;
(function (SchedulerHeaderTab) {
    SchedulerHeaderTab["OFFER_BOOKING_TIME"] = "OFFER_BOOKING_TIME";
    SchedulerHeaderTab["INSTANT_MEETING"] = "INSTANT_MEETING";
})(SchedulerHeaderTab = exports.SchedulerHeaderTab || (exports.SchedulerHeaderTab = {}));
var SchedulerLocationPhoneTab;
(function (SchedulerLocationPhoneTab) {
    SchedulerLocationPhoneTab["HOST_PHONE_NUMBER"] = "HOST_PHONE_NUMBER";
    SchedulerLocationPhoneTab["PROMPT_INVITE"] = "PROMPT_INVITE";
    SchedulerLocationPhoneTab["CUSTOM_PHONE"] = "CUSTOM_PHONE";
})(SchedulerLocationPhoneTab = exports.SchedulerLocationPhoneTab || (exports.SchedulerLocationPhoneTab = {}));
var VideoIntegrationType;
(function (VideoIntegrationType) {
    VideoIntegrationType["ZOOM"] = "ZOOM";
    VideoIntegrationType["GOOGLE_MEET"] = "GOOGLE_MEET";
    VideoIntegrationType["MICROSOFT_TEAMS"] = "MICROSOFT_TEAMS";
})(VideoIntegrationType = exports.VideoIntegrationType || (exports.VideoIntegrationType = {}));
var IntegrationType;
(function (IntegrationType) {
    IntegrationType["GOOGLE_CALENDAR"] = "GOOGLE_CALENDAR";
    IntegrationType["MICROSOFT_CALENDAR"] = "MICROSOFT_CALENDAR";
    IntegrationType["ZOOM"] = "ZOOM";
    IntegrationType["GOOGLE_MEET"] = "GOOGLE_MEET";
    IntegrationType["MICROSOFT_TEAMS"] = "MICROSOFT_TEAMS";
    IntegrationType["SUMO1"] = "SUMO1";
    IntegrationType["GOOGLE_CONTACTS"] = "GOOGLE_CONTACTS";
    IntegrationType["MICROSOFT_CONTACTS"] = "MICROSOFT_CONTACTS";
    IntegrationType["CHATWOOT"] = "CHATWOOT";
    IntegrationType["WEB_PUSH"] = "WEB_PUSH";
    IntegrationType["OUR_PAGE"] = "OUR_PAGE";
    IntegrationType["SALESFORCE"] = "SALESFORCE";
})(IntegrationType = exports.IntegrationType || (exports.IntegrationType = {}));
var WorkspaceIntegrationType;
(function (WorkspaceIntegrationType) {
    WorkspaceIntegrationType["SUMO1"] = "SUMO1";
    WorkspaceIntegrationType["SALESFORCE"] = "SALESFORCE";
    WorkspaceIntegrationType["HUBSPOT"] = "HUBSPOT";
    WorkspaceIntegrationType["SALESFORCE_CEP"] = "SALESFORCE_CEP";
    WorkspaceIntegrationType["MS_DYNAMICS"] = "MS_DYNAMICS";
})(WorkspaceIntegrationType = exports.WorkspaceIntegrationType || (exports.WorkspaceIntegrationType = {}));
var InputFieldType;
(function (InputFieldType) {
    InputFieldType["TEXT"] = "TEXT";
    InputFieldType["EMAIL"] = "EMAIL";
    InputFieldType["PHONE"] = "PHONE";
    InputFieldType["DATE"] = "DATE";
    InputFieldType["TIME"] = "TIME";
    InputFieldType["NUMBER"] = "NUMBER";
    InputFieldType["BOOLEAN"] = "BOOLEAN";
})(InputFieldType = exports.InputFieldType || (exports.InputFieldType = {}));
var InputFieldFieldType;
(function (InputFieldFieldType) {
    InputFieldFieldType["NAME"] = "NAME";
    InputFieldFieldType["EMAIL"] = "EMAIL";
    InputFieldFieldType["PHONE"] = "PHONE";
    InputFieldFieldType["DATE"] = "DATE";
    InputFieldFieldType["TIME"] = "TIME";
    InputFieldFieldType["NUMBER"] = "NUMBER";
    InputFieldFieldType["BOOLEAN"] = "BOOLEAN";
    InputFieldFieldType["LOCATION"] = "LOCATION";
})(InputFieldFieldType = exports.InputFieldFieldType || (exports.InputFieldFieldType = {}));
var TenantStatus;
(function (TenantStatus) {
    TenantStatus["ACTIVE"] = "ACTIVE";
    TenantStatus["EXPIRED"] = "EXPIRED";
})(TenantStatus = exports.TenantStatus || (exports.TenantStatus = {}));
